
// Dashboard Analytics
export const DASHBOARD_ANALYTICS_PERMISSIONS = {
  DASHBOARD_ANALYTICS: {
    VIEW: 'VIEW_CUSTOMER_REPORT',  
  },
};

// Point Account
export const POINT_ACCOUNT_PERMISSIONS = {
  POINT_ACCOUNT: {
    VIEW: 'VIEW_POINT_ACCOUNT',
    UPDATE: 'VIEW_POINT_ACCOUNT',
  },
};

// Earnings
export const EARNINGS_PERMISSIONS = {
  VIEW_REDEMPTIONS: {
    VIEW: 'VIEW_REDEMPTIONS',
    SEARCH: 'SEARCH_REDEMPTIONS',
    DOWNLOAD: 'DOWNLOAD_REDEMPTIONS',
  },
  POPULAR_MERCHANTS: {
    VIEW: 'VIEW_POPULAR_MERCHANTS',
    DOWNLOAD: 'DOWNLOAD_POPULAR_MERCHANTS',
  },
};

// Security Logs
export const SECURITY_LOGS_PERMISSIONS = {
  IP_LOGS: {
    VIEW: 'VIEW_IP_LOGS',
    RESET: 'RESET_IP_LOGS',
  },
  OTP_LOGS: {
    VIEW: 'VIEW_OTP_LOGS',
    SEARCH: 'VIEW_OTP_LOGS',
    RESET: 'RESET_OTP_LOGS',
  },
};

// Role Management
export const ROLE_MANAGEMENT_PERMISSIONS = {
  ROLE_PERMISSIONS: {
     VIEW: 'UPDATE_ROLE',
  },
  CREATE_ROLE: {
    VIEW: 'CREATE_ROLE',
  },
  VIEW_ROLES: {
    VIEW: 'VIEW_ROLES',
  },
};

// User Management
export const USER_MANAGEMENT_PERMISSIONS = {
  VIEW_USERS: {
    VIEW: 'VIEW_ADMIN_USERS',
    UPDATE: 'UPDATE_ADMIN_USERS',
    DELETE: 'DELETE_ADMIN_USERS',
  },
  ADD_USERS: {
    CREATE: 'CREATE_ADMIN_USERS',
  },
  VIEW_CUSTOMERS: {
    VIEW: 'VIEW_CUSTOMER_DETAILS',
    UPDATE_MOBILE: 'UPDATE_CUSTOMER_MOBILE_NUMBER',
    MANAGE: 'ACTIVATE_DEACTIVATE_CUSTOMER_ACCOUNT',
    FILTER:'SEARCH_CUSTOMER_ACCOUNTS',
    DOWNLOAD: 'DOWNLOAD_CUSTOMER_ACCOUNTS',
  },
};

// Tier Management
export const TIER_MANAGEMENT_PERMISSIONS = {
  VIEW_TIERS: {
    VIEW: 'VIEW_LOYALTY_TIERS',
    UPDATE: 'UPDATE_LOYALTY_TIER',
    DELETE: 'DELETE_LOYALTY_TIER',
  },
  ADD_TIER: {
    CREATE: 'CREATE_LOYALTY_TIER',
  },
};

// MCC Code Management
export const MCC_MANAGEMENT_PERMISSIONS = {
  VIEW_MCC_CODES: {
    VIEW: 'VIEW_MCC_CODES',
    UPDATE: 'UPDATE_MCC_CODES',
    DELETE: 'DELETE_MCC_CODES',
  },
  ADD_MCC_CODE: {
    CREATE: 'CREATE_MCC_CODES',
  },
};

// Reward Rule Management
export const REWARD_RULE_MANAGEMENT_PERMISSIONS = {
  MANAGE_RULES: {
    VIEW: 'VIEW_REWARD_RULES',
    UPDATE: 'UPDATE_REWARD_RULE',
    ACTIVATE_RULE: 'ACTIVATE_DEACTIVATE_REWARD_RULES',
    DELETE: 'DELETE_REWARD_RULE',
  },
  ADD_RULE: {
    CREATE: 'CREATE_REWARD_RULE',
  },
};

// Audit Log Management
export const AUDIT_LOG_PERMISSIONS = {
  AUDIT_LOGS: {
    VIEW: 'VIEW_AUDIT_LOGS',
  },
};

// SMS & Communication
export const SMS_PERMISSIONS = {
  SMS_TEMPLATES: {
    VIEW: 'VIEW_SMS_TEMPLATE',
    UPDATE: 'UPDATE_SMS_TEMPLATE',
  },
};

// Failed Batch Records
export const FAILED_BATCH_PERMISSIONS = {
  FAILED_RECORDS: {
    VIEW: 'VIEW_BATCH_FAILED_RECORDS',
    DOWNLOAD: 'DOWNLOAD_BATCH_FAILED_RECORDS',
  },
};



export const PERMISSION_DEPENDENCIES = {
  [POINT_ACCOUNT_PERMISSIONS.POINT_ACCOUNT.VIEW]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [MCC_MANAGEMENT_PERMISSIONS.ADD_MCC_CODE.CREATE]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [MCC_MANAGEMENT_PERMISSIONS.VIEW_MCC_CODES.VIEW]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [MCC_MANAGEMENT_PERMISSIONS.VIEW_MCC_CODES.UPDATE]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.UPDATE]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.VIEW,
    ROLE_MANAGEMENT_PERMISSIONS.VIEW_ROLES.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.DELETE]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_USERS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.ADD_USERS.CREATE]: [
    ROLE_MANAGEMENT_PERMISSIONS.VIEW_ROLES.VIEW,
  ],
  [ROLE_MANAGEMENT_PERMISSIONS.ROLE_PERMISSIONS.VIEW]: [
    ROLE_MANAGEMENT_PERMISSIONS.VIEW_ROLES.VIEW,
  ],
  [SMS_PERMISSIONS.SMS_TEMPLATES.UPDATE]: [
    SMS_PERMISSIONS.SMS_TEMPLATES.VIEW,
  ],
  [REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.UPDATE]: [
    REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW,
  ],
  [REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.ACTIVATE_RULE]: [
    REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW,
  ],
  [REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.DELETE]: [
    REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW,
  ],
  [REWARD_RULE_MANAGEMENT_PERMISSIONS.ADD_RULE.CREATE]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
    REWARD_RULE_MANAGEMENT_PERMISSIONS.MANAGE_RULES.VIEW,
  ],
  [TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.UPDATE]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.DELETE]: [
    TIER_MANAGEMENT_PERMISSIONS.VIEW_TIERS.VIEW,
  ],
  [EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.DOWNLOAD]: [
    EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.VIEW,
  ],
  [EARNINGS_PERMISSIONS.POPULAR_MERCHANTS.DOWNLOAD]: [
    EARNINGS_PERMISSIONS.POPULAR_MERCHANTS.VIEW,
  ],
  
  [EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.SEARCH]: [
    EARNINGS_PERMISSIONS.VIEW_REDEMPTIONS.VIEW,
  ],
  [SECURITY_LOGS_PERMISSIONS.IP_LOGS.RESET]: [
    SECURITY_LOGS_PERMISSIONS.IP_LOGS.VIEW,
  ],
  [SECURITY_LOGS_PERMISSIONS.OTP_LOGS.RESET]: [
    SECURITY_LOGS_PERMISSIONS.OTP_LOGS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.UPDATE_MOBILE]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.MANAGE]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.DOWNLOAD]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW,
  ],
  [USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.FILTER]: [
    USER_MANAGEMENT_PERMISSIONS.VIEW_CUSTOMERS.VIEW,
  ],
  [FAILED_BATCH_PERMISSIONS.FAILED_RECORDS.DOWNLOAD]: [
    FAILED_BATCH_PERMISSIONS.FAILED_RECORDS.VIEW,
  ],
};

